import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GoogleTagManagerModule } from './google-tag-manager/google-tag-manager.module';

@NgModule({
  imports: [CommonModule, GoogleTagManagerModule],
})
export class AnalyticsModule {}
